module.exports = __webpack_public_path__ + "static/media/04-_DSC0329.011155a2.jpg";